/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Bodyfat_TipInputs */

const en_us2_profile_editors_bodyfat_tip = /** @type {(inputs: Profile_Editors_Bodyfat_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a reading from a bioimpedance scale or calipers. Without one, leave it: the app estimates from your weight.`)
};

const pt_br2_profile_editors_bodyfat_tip = /** @type {(inputs: Profile_Editors_Bodyfat_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a medida de uma bioimpedância ou de um adipômetro. Sem ela, deixe como está: o app estima pelo peso.`)
};

const es_419_profile_editors_bodyfat_tip = /** @type {(inputs: Profile_Editors_Bodyfat_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa la lectura de una balanza de bioimpedancia o de un plicómetro. Si no tienes una, déjalo así: la app estima a partir de tu peso.`)
};

const pt_pt2_profile_editors_bodyfat_tip = /** @type {(inputs: Profile_Editors_Bodyfat_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa a medição de uma bioimpedância ou de um adipómetro. Sem ela, deixa como está: a app estima a partir do peso.`)
};

const fr_fr2_profile_editors_bodyfat_tip = /** @type {(inputs: Profile_Editors_Bodyfat_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilise la mesure d'une balance à impédancemétrie ou d'une pince à plis cutanés. Sans mesure, laisse tel quel : l'app l'estime à partir de ton poids.`)
};

const de_de2_profile_editors_bodyfat_tip = /** @type {(inputs: Profile_Editors_Bodyfat_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nimm den Wert einer Körperanalysewaage oder eines Fettkalipers. Ohne Messung lass es leer: Die App schätzt anhand deines Gewichts.`)
};

const it_it2_profile_editors_bodyfat_tip = /** @type {(inputs: Profile_Editors_Bodyfat_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa il valore di una bilancia impedenziometrica o di un plicometro. Se non ce l'hai, lascia così: l'app stima dal peso.`)
};

/**
* | output |
* | --- |
* | "Use a reading from a bioimpedance scale or calipers. Without one, leave it: the app estimates from your weight." |
*
* @param {Profile_Editors_Bodyfat_TipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_bodyfat_tip = /** @type {((inputs?: Profile_Editors_Bodyfat_TipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Bodyfat_TipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_bodyfat_tip(inputs)
	if (locale === "es-419") return es_419_profile_editors_bodyfat_tip(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_bodyfat_tip(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_bodyfat_tip(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_bodyfat_tip(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_bodyfat_tip(inputs)
	return en_us2_profile_editors_bodyfat_tip(inputs)
});
export { profile_editors_bodyfat_tip as "profile-editors.bodyfat_tip" }